import { createSelector } from 'reselect';
import { has, map } from 'lodash';
import { useSelector } from 'react-redux';
import { getUserToEdit } from '../users';
import { getAllDomainEntities, getDomainEntitiesById } from '../entities/selectors';
import { getCurrentOrg } from '../session';

export const getAvailableDomainEntities = createSelector(
  [getUserToEdit, getCurrentOrg, getDomainEntitiesById],
  (currentUser, currentOrg, availableDomains) => {
    if (currentUser?.custodian_for_orgs.some((org) => org.id === currentOrg?.id)) {
      return availableDomains;
    } else if (currentUser?.custodian_for_domains?.length) {
      const filteredDomains = availableDomains.filter((item) =>
        currentUser?.custodian_for_domains.includes(item?.id),
      );
      return filteredDomains;
    }
  },
);

export const getItemsByDomain = (state) => {
  return state.domains.itemsByDomain;
};

export const getMarketplaceItemEntities = (state) => {
  return state.entities.marketplaceItems;
};

export const getDomainItemsEntitiesByDomain = createSelector(
  [getItemsByDomain, getMarketplaceItemEntities],
  (itemsByDomain, marketplaceItems) => {
    if (!itemsByDomain || !marketplaceItems) return {};

    return Object.keys(itemsByDomain).reduce((acc, domainId) => {
      acc[domainId] = map(itemsByDomain[domainId] || [], (id) => marketplaceItems[id]);
      return acc;
    }, {});
  },
);

export const getMarketplaceItemEntityById = (state, id) => {
  const marketplaceItems = getMarketplaceItemEntities(state);
  return marketplaceItems ? marketplaceItems[id] : null;
};
